import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=70f3a778&scoped=true&"
import script from "./BaseForm.vue?vue&type=script&lang=ts&"
export * from "./BaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseForm.vue?vue&type=style&index=0&id=70f3a778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f3a778",
  null
  
)

export default component.exports